module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Bold.a302e35.woff2";